<template>
    <div class='page-container'>
        <TransparentHeader color="#FF273A" title-color="#FFFFFF" :customOpacity="1"/>
        <div class="panel prize-total" v-if="prizeTotalShow">
            <div class="prize-total-item van-hairline--bottom icon1" v-if="stat.cash_amount>0">
                <div class="item-left">现金红包 <span>{{ parseFloat(stat.cash_amount) }}元</span></div>
            </div>
            <div class="prize-total-item van-hairline--bottom icon2" v-if="stat.gy_red_amount >0">
                <div class="item-left">高佣红包 <span>{{ parseFloat(stat.gy_red_amount) }}元</span></div>
                <div class="use-btn" v-if="parseFloat(stat.gy_red_amount)" @click="goRedPacketCenter">使用高佣红包</div>
            </div>
            <div class="prize-total-item van-hairline--bottom icon3" v-if="stat.butler_day>0">
                <div class="item-left">大管家 <span>{{ stat.butler_day }}天</span></div>
            </div>
            <div class="prize-total-item icon4" v-if="stat.real_goods_list.length">
                <div class="item-left">实物奖品 <span>{{ stat.real_goods_num }}个</span></div>
                <div class="address-btn" v-if="stat.real_goods_num" @click="addressPop = true">收货地址</div>
            </div>
            <div class="real-prize-box" v-if="stat.real_goods_list.length">
                <template v-for="(item, index) in stat.real_goods_list">
                    <span :key="index">
                        {{item.prize_name}}*{{item.prize_value}}<i v-if="index != stat.real_goods_list.length - 1">，</i>
                    </span>
                </template>
            </div>
        </div>

        <div class="panel detail-panel">
            <p class="title">中奖明细</p>
            <div class="tip">注：如果单笔订单失效，关联到的开奖次数也会失效，开奖中的奖品会做失效处理</div>
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="list.length ? '亲，到底了哦～' : ''"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="getAwardList">
                <div class="detail-item van-hairline--bottom" v-for="(item, index) in list" :key="index">
                    <div class="detail-item-left">
                        <p class="prize-name">{{item.prize_name}}</p>
                        <p class="draw-time">{{item.draw_time | formatDate('YYYY-mm-dd HH:MM:SS')}}</p>
                    </div>
                    <div class="status" :class="{'valid' : item.draw_status === 1}">{{item.draw_status === 1 ? '有效' : '失效'}}</div>
                    <div class="invalid-reason" v-if="item.invalid_reason">{{item.invalid_reason}}</div>
                </div>
                <div class="no-data-tip" v-if="!list.length">
                    <img src="@/views/activity2022/assets/img/202212/nhj/jd_nodate@2x.png" alt="">
                    <p>暂无活动数据~</p>
                </div>
            </van-list>
        </div>

        <van-popup class="address-pop" v-model="addressPop">
            <div class="address-pop-con">
                <div class="row">
                    <div class="label">收件人</div>
                    <input class="input" type="text" placeholder="请输入收货人姓名" v-model.trim="addressInfo.consignee" maxlength="20">
                </div>
                <div class="row">
                    <div class="label">手机号</div>
                    <input class="input" type="text" placeholder="请输入联系方式" v-model.trim="addressInfo.phone" maxlength="11">
                </div>
                <div class="row">
                    <div class="label">收货地址</div>
                    <textarea class="textarea"  placeholder="省、市、区、街道、小区楼栋/乡镇名称等" v-model.trim="addressInfo.address" maxlength="100"></textarea>
                </div>
                <div class="tip">注：请填写正确的信息内容，以免获奖收不到奖品</div>
                <div class="submit-btn" :class="{'can-submit': addressInfoValid }" @click="submitAddressInfo">确认保存</div>
            </div>
            <div class="close-btn" @click="addressPop=false"></div>
        </van-popup>
    </div>
</template>
<script>
import TransparentHeader from "@/common/components/TransparentHeader";
import {mapState} from 'vuex'
import {awardList, saveAddress} from "@/views/activity2022/api/202212/nhj";
import Vue from 'vue';
import {List, Popup} from 'vant';
import {goodsJump} from "@/common/utils";
Vue.use(Popup);
Vue.use(List);
export default {
    name: 'myPrize',
    components: {
        TransparentHeader
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.common.userInfo
        }),
        addressInfoValid() {
            if (!this.addressInfo.consignee) {
                return false
            }
            if (!this.addressInfo.address || this.addressInfo.address.length < 7) {
                return false
            }
            if (!this.addressInfo.phone || !/^1[3-9]\d{9}$/.test(this.addressInfo.phone)) {
                return false
            }
            return true
        },
        prizeTotalShow() {
            if(this.stat.cash_amount>0 || this.stat.gy_red_amount>0 || this.stat.butler_day>0 || this.stat.real_goods_list.length){
                return true
            }
            return  false
        }
    },
    data() {
        return {
            stat: {
                cash_amount: 0,
                gy_red_amount: 0,
                butler_day: 0,
                real_goods_num: 0,
                real_goods_list: []
            },
            addressPop: false,
            addressInfo: {},
            list: [],
            listQuery: {
                page: 1,
                pageSize: 30
            },
            loading: false,
            finished: false,
            error: false
        }
    },
    created() {
        this.$uweb.trackEvent("activity2022", `2023_New_Year:我的奖品页浏览量`, this.$GY_platform.currentPlatform);
    },
    mounted() {
        document.body.style.backgroundColor = '#FF273A'
    },
    beforeDestroy() {
        document.body.style.backgroundColor = 'inherit'
    },
    methods: {
        getAwardList() {
            awardList(this.listQuery).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    const resData = res.data.data
                    if (this.listQuery.page == 1) {
                        this.stat = resData.stat
                        this.addressInfo = resData.shipping || {}
                    }
                    let list = resData.list || []
                    this.list = this.list.concat(list)
                    if (list.length < this.listQuery.pageSize) {
                        this.finished = true
                    } else {
                        this.listQuery.page++
                    }
                }
            }).catch(() => {
                this.error = true
            }).finally(() => {
                this.loading = false
            })
        },
        submitAddressInfo() {
            if (!this.addressInfo.consignee) {
                this.$toast('请填写收货人')
                return
            }
            if (!this.addressInfo.phone || !/^1[3-9]\d{9}$/.test(this.addressInfo.phone)) {
                this.$toast('请填写正确的联系电话')
                return
            }
            if (!this.addressInfo.address || this.addressInfo.address.length < 7) {
                this.$toast('请填写正确的详细地址')
                return
            }
            if (this.addressInfoValid) {
                saveAddress(this.addressInfo).then(res => {
                    if (res.data.code == 200) {
                        this.$toast('保存成功')
                        this.addressPop = false
                    }
                })
            }
        },
        // 去使用高佣红包
        goRedPacketCenter() {
            if (this.$GY_platform.isGYApp) {
                goodsJump({
                    type: 11,
                    appurl: `${window.location.origin}/app2021/red-packet/center`
                })
            }
        }
    }
}
</script>

<style scoped lang="less">
.page-container {
    padding: 176px 24px 68px;
    min-height: 100vh;
    user-select: none;
    background-color: #FF273A;

    .panel {
        padding: 0 24px 24px;
        margin: 0 auto 16px;
        width: 702px;
        min-height: 218px;
        border-radius: 30px;
        background-color: #fff;
        background-image: url(~@/views/activity2022/assets/img/202212/nhj/task_title_bj@2x.png);
        background-size: 100% auto;
        background-repeat: no-repeat;

        .prize-total-item {
            padding-left: 76px;
            height: 128px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &::after {
                border-color: rgba(155, 44, 10, .1);
            }

            &.icon1 {
                background-image: url(~@/views/activity2022/assets/img/202212/nhj/wdjp_icon_xjhb@2x.png);
                background-size: 60px 60px;
                background-position: center left;
                background-repeat: no-repeat;
            }
            &.icon2 {
                background-image: url(~@/views/activity2022/assets/img/202212/nhj/wdjp_icon_gyhb@2x.png);
                background-size: 60px 60px;
                background-position: center left;
                background-repeat: no-repeat;
            }
            &.icon3 {
                background-image: url(~@/views/activity2022/assets/img/202212/nhj/wdjp_icon_dgj@2x.png);
                background-size: 60px 60px;
                background-position: center left;
                background-repeat: no-repeat;
            }
            &.icon4 {
                background-image: url(~@/views/activity2022/assets/img/202212/nhj/wdjp_icon_swjp@2x.png);
                background-size: 60px 60px;
                background-position: center left;
                background-repeat: no-repeat;
            }

            .item-left {
                display: flex;
                align-items: center;
                color: #9B2C0A;
                font-size: 28px;
                span {
                    margin-left: 16px;
                    color: #FF273A;
                    font-size: 34px;
                }
            }

            .use-btn {
                width: 192px;
                height: 52px;
                background: linear-gradient(135deg, #FF2764 0%, #FF273A 100%);
                border-radius: 44px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 24px;
                color: #ffffff;
            }
            .address-btn {
                width: 144px;
                height: 52px;
                border-radius: 32px;
                border: 2px solid #FF273A;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #FF273A;
                font-size: 24px;
            }


        }
        .real-prize-box {
            padding: 18px 16px;
            border-radius: 16px;
            border: 1px solid #FFD6DA;
            background: rgba(255,39,58,0.06);
            font-size: 24px;
            color: #9B2C0A;
            opacity: .7;
        }
    }

    .detail-panel {
        .title {
            height: 96px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FF273A;
            font-size: 34px;
            font-weight: bold;
        }
        .tip {
            margin-bottom: 16px;
            padding: 16px;
            background: rgba(255,39,58,0.06);
            border-radius: 16px;
            border: 1px solid #FFD6DA;
            color: #FF273A;
            font-size: 24px;
            line-height: 1.5;
        }

        .detail-item {
            padding: 24px 0;
            min-height: 126px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;

            &::after {
                border-color: rgba(155, 44, 10, .1);
            }

            .prize-name {
                height: 40px;
                line-height: 40px;
                color: #9B2C0A;
                font-size: 28px;
                font-weight: bold;
            }
            .draw-time {
                margin-top: 4px;
                height: 34px;
                font-size: 24px;
                color: #9B2C0A;
                opacity: .7;
            }

            .status {
                font-size: 24px;
                color: #FF273A;
                &.valid {
                    color: #9B2C0A;
                }
            }

            .invalid-reason {
                margin-top: 24px;
                margin-bottom: 2px;
                padding: 12px 16px;
                width: 100%;
                background: #F5F5F5;
                border-radius: 8px;
                font-size: 22px;
                color: #808080;
            }
        }
    }

    /deep/ .van-list {
        .van-list__finished-text {
            font-size: 22px;
            color: #9B2C0A;
            opacity: .7;
        }
    }

    .no-data-tip {
        margin: 96px auto 96px;
        width: 428px;
        height: 322px;
        position: relative;
        p {
            width: 100%;
            text-align: center;
            font-size: 28px;
            color: #9B2C0A;
            opacity: .7;
            position: absolute;
            bottom: 40px;
            left: 0;
        }
        img {
            display: block;
            width: 100%;
            height: 100%;
        }
    }


    .address-pop {
        background-color: transparent;

        .address-pop-con {
            padding: 64px 32px;
            width: 654px;
            height: 718px;
            background: #FFFFFF;
            border-radius: 30px;
            .row {
                margin-bottom: 32px;
                display: flex;
                justify-content: space-between;
                .label {
                    width: 140px;
                    height: 72px;
                    font-size: 30px;
                    color: #9B2C0A;
                    display: flex;
                    align-items: center;
                }
                .input, .textarea {
                    padding: 16px 20px;
                    flex: 1;
                    min-height: 72px;
                    background-color: #F5F5F5;
                    border-radius: 16px;
                    color: #9B2C0A;
                    font-size: 28px;
                    &::placeholder {
                        font-size: 28px;
                        color: #9B2C0A;
                        opacity: .6;
                    }
                }
                .textarea {
                    min-height: 152px;
                }

            }
            .tip {
                color: #9B2C0A;
                font-size: 24px;
                opacity: .6;
            }
            .submit-btn {
                margin: 82px auto 0;
                width: 360px;
                height: 88px;
                background: linear-gradient(135deg, #FF2764 0%, #FF273A 100%);
                border-radius: 44px;
                opacity: 0.6;
                font-size: 34px;
                color: #FFFFFF;
                display: flex;
                justify-content: center;
                align-items: center;
                &.can-submit {
                    opacity: 1;
                }
            }
        }
        .close-btn {
            height: 144px;
            background-image: url(~@/views/activity2022/assets/img/202212/1212/zq_icon_close.png);
            background-size: 80px 80px;
            background-repeat: no-repeat;
            background-position: bottom center;
        }
    }

}
</style>
